import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CustomerMembership, CustomerMembershipCustomer } from '../../../../../../../../../../models/membership';
import { OrganizationConfigService } from '../../../../../../../../../../services/organization-config/organization-config.service';
import { CustomerService } from '../../../../../../../../../../services/customer/customer.service';


@Component({
  selector: 'app-remove-group-membership-member-next-bill-date',
  templateUrl: './remove-group-membership-member-next-bill-date.component.html',
  styleUrls: ['./remove-group-membership-member-next-bill-date.component.css']
})
export class RemoveGroupMembershipMemberNextBillDateComponent implements OnInit, OnDestroy {

  @Input() membership: CustomerMembership;
  @Input() savedCallback: (successMessage: string) => undefined;
  @Input() saveClickedObservable: Observable<void>;
  @Output() loadingEvent = new EventEmitter<boolean>();
  @Output() serverErrorEvent = new EventEmitter<number>();

  public selectedMember: CustomerMembershipCustomer | null = null;

  public errorMessage = '';

  private saveClickedSubscription: Subscription;

  constructor(
    public orgConfig: OrganizationConfigService,
    private activeModal: NgbActiveModal,
    private customerService: CustomerService
  ) {}

  ngOnInit() {
    this.saveClickedSubscription = this.saveClickedObservable.subscribe(() => {
      this.handleSave();
    });
  }

  ngOnDestroy() {
    this.saveClickedSubscription.unsubscribe();
  }

  public availableMembers(): CustomerMembershipCustomer[] {
    return this.membership.all_customers.filter(cmc => {
      return (!cmc.is_pending_removal && !cmc.is_pending_addition);
    });
  }

  private handleSave() {
    this.errorMessage = '';

    if (this.membership.unlinked_customers.length > 0) {
      this.errorMessage = 'Membership has unlinked members.';
      return;
    }

    if (this.selectedMember === null) {
      this.errorMessage = 'Please select a member to remove from the membership.';
      return;
    }

    this.loadingEvent.emit(true);

    this.customerService
      .removeGroupMembershipMemberNextBillDate(this.membership.id, this.selectedMember.id)
      .then(() => {
        this.savedCallback('Member scheduled to be removed.');
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to remove this member from this membership.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverErrorEvent.emit(reason.status);
        }
      })
      .finally(() => { this.loadingEvent.emit(false); });
  }
}
